module.exports = __webpack_public_path__ + "static/media/iconunrestricted.c17752f4.svg";